import React from 'react';
import { CoreAppDispatches } from '../redux/core-app-state/types';

export const defaultDispatches = {
  logout: () => Promise.resolve(),
  openModal: () => Promise.resolve()
};

export const CoreDispatchesContext = React.createContext<CoreAppDispatches>(defaultDispatches);
